import { useContext } from 'react';
import { PortalElementContext } from './useStickyElementContext';
import { StickyElement } from './styled';

export const StickyElementForPortal = () => {
    const { setStickyElement }  = useContext(PortalElementContext);

    return <StickyElement ref={setStickyElement}/>;
};
